import { Grid, MenuItem, TextField } from "@material-ui/core"
import { useContext } from 'react';
import { FilterContainer } from 'components';
import { applicationContext } from 'helpers/services';
import { ReferenceData } from "helpers/enums";
import { ticketsContext } from "views/Tickets/TicketsContext";


let Filters = () => {
    let { referenceData } = useContext(applicationContext);
    let { supplier, setSupplier,updateSupplier } = useContext(ticketsContext);


    return (
        <FilterContainer>
            <Grid item>
                <TextField
                    label="Supplier"
                    select
                    value={supplier}
                    onChange={(e) => {
                        setSupplier(e.target.value)
                        updateSupplier(e.target.value || "")
                    }}
                >
                    <MenuItem value=''>Any</MenuItem>
                    {referenceData
                        .getByKey(ReferenceData.Supplier)?.values
                        .map(x => <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)
                    }
                </TextField>
            </Grid>
        </FilterContainer>
    )
}

export default Filters;
